import React, { useEffect, useState } from 'react';
import { CustomerContext } from '@thd-olt-functional/customer-information';
import {
  FlooringProjects,
  analytics as ConfiguratorProjectsAnalytics
} from '@thd-olt-component-react/configurator-projects';
import { Secure, Savings, ServicePro, HeartFilled } from '@one-thd/sui-icons';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { declareContexts } from '@thd-olt-component-react/hydrator';
import { QueryProvider } from '@thd-nucleus/data-sources';
import {
  Typography, Modal, ModalHeader, ModalBody, ModalFooter,
  Button, ButtonGroup, Link,
  Accordion, AccordionBody, AccordionHeader
} from '@one-thd/sui-atomic-components';
import { configuratorBreadcrumbsData } from '../../constants';

/*
  **IMPORTANT**
  This page must be ran in stage locally to try it out
    You need an account in stage with the same email as the one you use to login to prod
    This is because while local stage uses the stage GCC API, it uses your prod login for some reason
*/
export const ConfiguratorProjects = () => {
  declareContexts([CustomerContext]);
  const [modalOpen, setModalOpen] = useState(false);
  const [accordionExpanded, setAccordionExpanded] = useState(false);

  useEffect(() => {
    if (!window.THDCustomer.default.isLoggedIn) {
      setModalOpen(true);
    }
  }, []);

  const signInRedirect = (location) => {
    if (typeof window !== 'undefined' && window.location) {
      window.location.href = `/auth/view/${location}?redirect=${window.location.pathname}`;
    }
  };

  return (
    <QueryProvider cacheKey="configurator-projects">
      <Modal size="sm" open={modalOpen} onClose={() => setModalOpen(false)}>
        <ModalHeader onClose={() => setModalOpen(false)} />
        <ModalBody>
          <div className="sui-flex sui-h-24 sui-flex-col sui-justify-center">
            <Typography variant="h3" weight="bold">Please log in to access the Configurator Projects Page</Typography>
          </div>
        </ModalBody>
        <ModalFooter position="start">
          <ButtonGroup orientation="vertical">
            <Button variant="primary" onClick={() => signInRedirect('signin')}>
              Sign in
            </Button>
            <Button variant="secondary" onClick={() => signInRedirect('createaccount')}>
              Create An Account
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </Modal>
      <div className="sui-w-full sui-max-w-screen-2xl sui-mx-auto sui-my-0 sui-flex-auto sui-flex-wrap sui-p-3">
        <Breadcrumbs data={configuratorBreadcrumbsData} />
        <FlooringProjects />
        <hr />
        <div className="sui-mt-8">
          <Accordion
            expanded={accordionExpanded}
            onChange={() => setAccordionExpanded((prev) => {
              if (!prev) {
                ConfiguratorProjectsAnalytics.triggerWhyThdInstallersAnalytics();
              }
              return !prev;
            })}
          >
            <AccordionHeader>
              Why Home Depot Installers?
            </AccordionHeader>
            <AccordionBody>
              <div
                className={'sui-grid sui-grid-cols-1 sui-gap-8 sui-grid-rows-auto '
                + 'md:sui-grid-cols-2 md:sui-grid-rows-2'}
              >
                <div className="sui-flex sui-flex-col sui-gap-4">
                  <div className="sui-flex sui-flex-row sui-gap-2">
                    <Secure size="large" />
                    <Typography weight="bold" variant="body-lg">
                      Licensed
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      The Home Depot&apos;s flooring installation professionals and contractors are local,
                      licensed, insured, and undergo a thorough background screening process.
                    </Typography>
                  </div>
                </div>
                <div className="sui-flex sui-flex-col sui-gap-4">
                  <div className="sui-flex sui-flex-row sui-gap-2">
                    <ServicePro size="large" />
                    <Typography weight="bold" variant="body-lg">
                      Subfloor Evaluation
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      We&apos;ll evaluate the structure and existing conditions under
                      your floor to help ensure a smooth installation of your new floors.
                    </Typography>
                  </div>
                </div>
                <div className="sui-flex sui-flex-col sui-gap-4">
                  <div className="sui-flex sui-flex-row sui-gap-2">
                    <Savings size="large" />
                    <Typography weight="bold" variant="body-lg">
                      Financing
                    </Typography>
                  </div>
                  <div className="sui-flex sui-flex-col sui-gap-4">
                    <Typography>
                      We offer a wide range of affordable financing options,
                      including the Home Depot Consumer Credit Card and The Home Depot Project Loan.
                    </Typography>
                    <Link href="/c/credit-center">Apply Now</Link>
                  </div>
                </div>
                <div className="sui-flex sui-flex-col sui-gap-4">
                  <div className="sui-flex sui-flex-row sui-gap-2">
                    <HeartFilled color="brand" size="large" />
                    <Typography weight="bold" variant="body-lg">
                      Backed by The Home Depot
                    </Typography>
                  </div>
                  <div>
                    <Typography>
                      All labor, products, and installation for your
                      project are 100% backed by The Home Depot.
                    </Typography>
                  </div>
                </div>
              </div>
            </AccordionBody>
          </Accordion>
        </div>
      </div>
    </QueryProvider>
  );
};

ConfiguratorProjects.displayName = 'ConfiguratorProjects';